import classNames from 'classnames';
import React, { HTMLProps, useCallback } from 'react';
import Link, { LinkProps } from 'next/link';

import css from './BooksOutlineButton.module.scss';

export enum Sizing {
  Small = 'small',
}

export enum TagType {
  A = 'a',
  Button = 'button',
  Span = 'span',
  Div = 'div',
}

interface Props extends HTMLProps<{}> {
  href?: string;
  linkTo?: string;
  value?: number;
  onClick?: (event: React.MouseEvent) => void;
  sizing?: Sizing;
  tag?: TagType | React.ComponentType<LinkProps>;
}

const BooksOutlineButton: React.FC<Props> = ({
  className,
  disabled,
  href,
  linkTo,
  onClick,
  sizing,
  tag,
  value,
  ...attr
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent) => {
      if (disabled) {
        event.preventDefault();
        return;
      }

      if (onClick) {
        onClick(event);
      }
    },
    [disabled, onClick],
  );

  let Tag: React.ElementType = tag || TagType.Button;
  if (linkTo) {
    Tag = Link;
  }
  const classes = classNames(
    css.BooksOutlineButton,
    className,
    sizing === Sizing.Small ? css.isSmall : '',
  );

  return (
    <Tag
      {...attr}
      className={classes}
      disabled={disabled}
      value={value}
      onClick={handleClick}
    />
  );
};

export default BooksOutlineButton;
